import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useQuery, gql } from "@apollo/client";
import ConfirmationVisit from "./ConfirmationVisit";
import { TConfirmationData } from "./types";

const GET_LINK = gql`
  query GetLink($id: String!) {
    link(id: $id) {
      recId
      id
      url
    }
  }
`;

export default function ConfirmationVisitController() {
  const location = useLocation();
  const [confirmationData, setConfirmationData] = useState<TConfirmationData | null>(null);
  const [isShow, setIsShow] = useState(false);

  const params = new URLSearchParams(location.search);
  const linkId = params.get("l");

  const { data } = useQuery(GET_LINK, {
    variables: { id: linkId },
    skip: !linkId,
  });

  useEffect(() => {
    if (data?.link?.url) {
      const url = new URL(data.link.url);
      const params = new URLSearchParams(url.search);
      const lesson = params.get("lesson");
      const pass = params.get("pass");
      const name = params.get("name");
      const direction = params.get("direction");
      const branch = params.get("branch");
      const date = params.get("date");
      const confirmTrue = params.get("confirmTrue");
      const confirmFalse = params.get("confirmFalse");

      if (lesson && pass && name && direction && branch && date && confirmTrue && confirmFalse) {
        setConfirmationData({ lesson, pass, name, direction, branch, date, confirmTrue, confirmFalse });
        setIsShow(true);
      }
    }
  }, [data]);

  if (!isShow || !confirmationData) return null;

  return <ConfirmationVisit data={confirmationData} />;
}
